import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import ToggleButton from '@material-ui/lab/ToggleButton';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { capitaliseStr } from '../../constants';
import { convertTimeToSeconds, convertTimeFromSeconds } from '../../utils/time';

class DeliveryOptionPage extends Component {
    formatPrice(price) {
        const currency = '£';
        const regex = /^[0-9]*\.?[0-9]*$/;
        if (!regex.test(`${price}`)) {
            return `${currency}${price.replace(/[^0-9.]/g, '')}`;
        }
        return `${currency}${price}`;
    }

    render() {
        const { editDelivery, onFieldChange, onChannelRemove, onChannelAdd } = this.props;

        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="float-left">
                            <h4 className="deliveryoption-name-header">{editDelivery.name}</h4>
                        </div>
                        <div className="float-right">
                            <p className="active-text">
                                STATUS:
                                <span>{editDelivery ? ' ACTIVE' : ' INACTIVE'}</span>
                            </p>
                            <ToggleButton
                                className="active-toggle"
                                value="check"
                                name="active"
                                selected={editDelivery.active === true}
                                onChange={() => onFieldChange('active', !editDelivery.active)}
                            >
                                <CheckIcon />
                            </ToggleButton>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-row">
                            <div className="col-md-2">
                                <label htmlFor="name">Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    className="form-control"
                                    onChange={e => onFieldChange(e.target.name, e.target.value)}
                                    value={editDelivery.name}
                                />
                            </div>
                            <div className="col-md-2">
                                <label htmlFor="code">Display name</label>
                                <input
                                    type="text"
                                    name="code"
                                    className="form-control"
                                    onChange={e => onFieldChange(e.target.name, e.target.value)}
                                    value={editDelivery.code}
                                />
                            </div>
                            <div className="col-md-1">
                                <label htmlFor="price">Price</label>

                                <div className="input-group mb-3 price-container">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="price"
                                        onChange={e => onFieldChange(e.target.name, e.target.value)}
                                        value={this.formatPrice(editDelivery.price)}
                                    />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <label htmlFor="store">Store</label>

                                <div className="input-group mb-3">
                                    <select
                                        name="store"
                                        className="form-control"
                                        onChange={e => onFieldChange(e.target.name, e.target.value)}
                                    >
                                        {this.props.stores.map((store, key) => {
                                            const selected = editDelivery.store === store;
                                            const formattedStoreName = capitaliseStr(store);
                                            return (
                                                <option key={key} value={store} selected={selected}>
                                                    {formattedStoreName}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="store">Channel</label>

                                <div className="input-group mb-3">
                                    <div className="channel-outer-container form-control">
                                        <div className="channel-inner-container">
                                            {editDelivery.channels.map((channel, key) => {
                                                const formattedChannelName = capitaliseStr(channel);
                                                return (
                                                    <div
                                                        key={key}
                                                        value={channel}
                                                        className="channel-item"
                                                    >
                                                        <span
                                                            onClick={e => onChannelRemove(channel)}
                                                            className="icon-cont"
                                                        >
                                                            <CloseIcon />
                                                        </span>
                                                        <span className="text-cont">
                                                            {formattedChannelName}
                                                        </span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    <div className="input-group-append">
                                        <select
                                            onChange={e => onChannelAdd(e.target.value)}
                                            className="input-group-text"
                                            name="add-channel"
                                        >
                                            <option value="">Add new</option>
                                            {this.props.channels.map((channel, key) => {
                                                if (editDelivery.channels.includes(channel))
                                                    return null;
                                                const formattedStoreName = capitaliseStr(channel);
                                                return (
                                                    <option key={key} value={channel}>
                                                        {formattedStoreName}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-row">
                            <div className="col-md-10">
                                <label htmlFor="description">Description</label>
                                <textarea
                                    type="text"
                                    name="description"
                                    className="form-control"
                                    defaultValue={editDelivery.description}
                                    onChange={e => onFieldChange(e.target.name, e.target.value)}
                                ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-row">
                            <div className="col-md-2">
                                <label htmlFor="cutOffTime">Cut Off Time</label>
                                <input
                                    type="time"
                                    name="cutOffTime"
                                    className="form-control"
                                    onChange={e =>
                                        onFieldChange(
                                            e.target.name,
                                            convertTimeToSeconds(e.target.value)
                                        )
                                    }
                                    value={convertTimeFromSeconds(editDelivery.cutOffTime)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        channels: state.utils.channels,
        stores: state.utils.stores,
    };
}

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryOptionPage);
